import { useMutation } from '@tanstack/react-query';

import { LitigationFormData } from '../types';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { MutationConfig, queryClient } from '@/lib/react-query';

const createLitigation =
  (makeRequest: any, shipmentId: string) =>
  async ({
    litigationData,
  }: {
    litigationData: LitigationFormData;
  }): Promise<void> => {
    const { data, error } = await makeRequest({
      path: `/shipments/${shipmentId}/litigations`,
      method: 'post',
      body: litigationData,
    });

    if (!data || error) {
      throw new Error(error);
    }
  };

type UseCreateLitigation = {
  config?: MutationConfig<ReturnType<typeof createLitigation>>;
  shipmentId: string;
};

export const useCreateLitigation = ({
  config,
  shipmentId,
}: UseCreateLitigation) => {
  const [, makeRequest] = useImperativeRequestWrapper('shipmentV3');

  return useMutation({
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: ['litigation', shipmentId],
      });
    },
    ...config,
    mutationFn: createLitigation(makeRequest, shipmentId),
  });
};
